import { useEffect, useState } from "react";
import { AssetImgProps } from "../types";

const sanitizeImagePath = (path: string) => {
  const sanitizedPath = path.replace(/[^a-zA-Z0-9\-/._]/g, ''); 
  return sanitizedPath;
};

/**const srcSetImg = ({ type, srcSet }: AssetImgPropsSrcSet) => {
  const loadedObject = {
    small: false,
    medium: false,
    large: false,
  }
  
  srcSet.small.path = sanitizeImagePath(srcSet.small.path);
  srcSet.medium.path = sanitizeImagePath(srcSet.medium.path);
  srcSet.large.path = sanitizeImagePath(srcSet.large.path);

  useEffect(() => {
    const smallImage = new Image();
    const mediumImage = new Image();
    const largeImage = new Image();
    smallImage.src = `/img/${type}/${srcSet.small.path}`;
    mediumImage.src = `/img/${type}/${srcSet.medium.path}`;
    mediumImage.src = `/img/${type}/${srcSet.large.path}`;
    smallImage.onload = () => {
      loadedObject.small = true;
    };
    mediumImage.onload = () => {
      loadedObject.medium = true;
    };
    largeImage.onload = () => {
      loadedObject.large = true;
    };
  })
  
  return loadedObject.small && loadedObject.medium && loadedObject.large ? (
    <img
      src={`/img/${type}/${srcSet.medium.path}`}
      srcSet={`/img/${type}/${srcSet.small.path} ${srcSet.small.size}, /img/${type}/${srcSet.large.path} ${srcSet.large.size}`}
      sizes={srcSet.medium.size}
      alt={srcSet.medium.path}
    />
  ) : (<div />)
}

const srcImg = ({ src, type, width, height }: AssetImgPropsSrc) => {
  const loadedObject = {
    src: false,
    small: false,
    medium: false,
    large: false,
  }

  useEffect(() => {
    src = sanitizeImagePath(src as string);

    const img = new Image();
    img.src = `/img/${type}/${src}`;
    img.onload = () => {
      loadedObject.src = true;
    };
  })
  
  return src ? (
    <img src={`/img/${type}/${src}`} alt={src} width={width} height={height} />
  ) : (<div />)
}*/


export const AssetImg = ({ src, width, height, type, srcSet }: AssetImgProps) => {
  const [loadedSmall, setLoadedSmall] = useState("");
  const [loadedMedium, setLoadedMedium] = useState("");
  const [loadedLarge, setLoadedLarge] = useState("");
  const [loadedSrc, setLoadedSrc] = useState("");

  useEffect(() => {
    if (srcSet) {
      const sanitizedSmall = sanitizeImagePath(srcSet.small.path);
      const sanitizedMedium = sanitizeImagePath(srcSet.medium.path);
      const sanitizedLarge = sanitizeImagePath(srcSet.large.path);
      
      const smallImage = new Image();
      const mediumImage = new Image();
      const largeImage = new Image();

      smallImage.src = `/img/${type}/${sanitizedSmall}`;
      mediumImage.src = `/img/${type}/${sanitizedMedium}`;
      largeImage.src = `/img/${type}/${sanitizedLarge}`;
      smallImage.onload = () => {
        setLoadedSmall(smallImage.src);
      };
      mediumImage.onload = () => {
        setLoadedMedium(mediumImage.src);
      };
      largeImage.onload = () => {
        setLoadedLarge(largeImage.src);
      };
    } else {
      const sanitizedSrc = sanitizeImagePath(src as string);

      const srcImg = new Image();

      srcImg.src = `/img/${type}/${sanitizedSrc}`;
      srcImg.onload = () => {
        setLoadedSrc(srcImg.src);
      };
    }
  })
  
  if (srcSet) {
    return loadedSmall && loadedMedium && loadedLarge ? (
      <img
        src={`${loadedMedium}`}
        srcSet={`${loadedSmall} ${srcSet.small.size}, ${loadedLarge} ${srcSet.large.size}`}
        sizes={srcSet.medium.size}
        alt={srcSet.medium.path}
      />
    ) : (<div />)
  }
  
  return loadedSrc ? (
    <img src={`${loadedSrc}`} alt={src} width={width} height={height} />
  ) : (<div />)
};
